module.exports = __webpack_public_path__ + "static/media/Southgrove utility sink 4.3cd06d80.JPG";